import logger from '../../utils/logger';

type PermissionsGroup = Record<string, string[]>;
type Permissions = {
  allow: PermissionsGroup;
  deny: PermissionsGroup;
};
type AuthState = {
  accessToken: string | null;
  userId: string | null;
  userType: string | null;
  userRoles: any | null;
  userName: string | null;
  permissions: Permissions | null;
  advertiserId: string | null;
  role: string | null;
};

const authReducer = (
  state: Partial<AuthState> | any,
  action: Partial<AuthState> & { type: string },
): Partial<AuthState> => {
  if (!state) state = {};
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      logger.debug('Login Success');

      return {
        ...state,
        accessToken: action.accessToken,
        userId: action.userId,
        userType: action.userType,
        userRoles: action.userRoles,
        userName: action.userName,
        permissions: action.permissions,
        advertiserId: action.advertiserId,
      };

    case 'SET_ADVERTISER':
      return {
        ...state,
        advertiserId: action.advertiserId,
        permissions: action.permissions,
        role: action.role,
      };

    case 'UNSET_ADVERTISER':
      return {
        ...state,
        advertiserId: null,
        permissions: null,
        role: null,
      };

    case 'LOGOUT':
      logger.debug('Logout');

      return {
        ...state,
        accessToken: null,
        userId: null,
        userRoles: null,
        userType: null,
        userName: null,
        permissions: null,
        advertiserId: null,
        virtualLogin: null,
      };

    case 'UPDATE_ACCESS_TOKEN':
      return {
        ...state,
        accessToken: action.accessToken,
      };

    default:
      return state;
  }
};

export default authReducer;
